<template>
    <b-card no-body>
        <b-tabs v-model="tabIndex" justified nav-class="nav-tabs-inverse" nav-wrapper-class="nav-tabs-inverse">
            <div class="p-20">
                <!-- begin tab -->
                <b-tab @click="navigateTo('storyboards')">
                    <template slot="title">
                        <span class="d-sm-none">Tab 1</span>
                        <span class="d-sm-block d-none">Storyboards</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab @click="navigateTo('stages')">
                    <template slot="title">
                        <span class="d-sm-none">Tab 2</span>
                        <span class="d-sm-block d-none">Stages</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab @click="navigateTo('steps')">
                    <template slot="title">
                        <span class="d-sm-none">Tab 3</span>
                        <span class="d-sm-block d-none">Steps</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin nav-tabs-pills -->
                <div class="row p-b-20">
                    <div class="col-6">
                    </div>
                    <div class="col-6">
                        <url-button v-if="$route.path.includes('storyboards')" label="Create new" :url="'/storyboard/new'" class="btn-yellow pull-right" />
                        <url-button v-if="$route.path.includes('stages')" label="Create new" :url="'/storyboard/stage/new'" class="btn-yellow pull-right" />
                        <url-button v-if="$route.path.includes('steps')" label="Create new" :url="'/storyboard/step/new'" class="btn-yellow pull-right" />
                    </div>
                </div>
                <!-- end nav-tabs-pills -->
                <router-view
                    v-bind:storyboards="storyboards"
                    v-bind:stages="stages"
                    v-bind:steps="steps"
                    v-bind:scriptItems="scriptItems"
                    v-bind:removeImage="removeImage"
                    v-bind:removeFile="removeFile"
                    v-bind:deleteNoteCall="deleteNoteCall"
                    v-bind:bulkDeleteStoryboards="bulkDeleteStoryboards"
                    v-bind:bulkDeleteStages="bulkDeleteStages"
                    v-bind:bulkDeleteSteps="bulkDeleteSteps"
                    v-bind:bulkSetStageStoryboards="bulkSetStageStoryboards"
                    v-bind:bulkSetStepStages="bulkSetStepStages"
                />
            </div>
        </b-tabs>
    </b-card>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'

export default {
    name: 'SearchTabs',
    props: [
        'storyboards',
        'stages',
        'steps',
        'activeEvent',
        'scriptItems',
        'removeImage',
        'removeFile',
        'deleteNoteCall',
        'bulkDeleteStoryboards',
        'bulkDeleteStages',
        'bulkDeleteSteps',
        'bulkSetStageStoryboards',
        'bulkSetStepStages',
    ],
    components: {
        UrlButton
    },
    data() {
        return {
            tabIndex: 0
        }
    },
    mounted() {
      this.$nextTick(() => {
        switch (this.$route.params.level) {
            case 'storyboards':
                this.tabIndex = 0;
                break;
            case 'stages':
                this.tabIndex = 1;
                break;
            case 'steps':
                this.tabIndex = 2;
                break;
            default:
                this.tabIndex = 0;
                break;
        }
      });
    },
    methods: {
        navigateTo(levelParam) {
            if (this.$route.params.level != levelParam) {
                this.$router.push({params: {level: levelParam}});
            }
        },
        filterStoryboards(event) {
            return this.storyboards.filter(function(sb) {
                return sb.event == event
            })
        },
        filterStages(event) {
            var storyboards = this.filterStoryboards(event);
            var fStages = [];
            storyboards.forEach(sb => {
                var stages = this.stages.filter(function(stage) {
                    return stage.storyboard == sb.id
                });
                stages.forEach(stage => {
                    if (!fStages.includes(stage) && stage.steps.length) {
                        fStages.push(stage);
                    }
                });
            });
            return fStages;
        },
        filterSteps(event) {
            var stages = this.filterStages(event);
            var fSteps = [];
            stages.forEach(stage => {
                var steps = this.steps.filter(function(step) {
                    return step.stage == stage.id
                });
                steps.forEach(step => {
                    if (!fSteps.includes(step)) {
                        fSteps.push(step);
                    }
                });
            });
            return fSteps;
        }
    }
}
</script>
